import { persisted } from '$lib/stores/cookieStore';
import type { components } from '$lib/api/backend-api-schema';

export type User = components['schemas']['UserDetails'];

export const user = persisted<User>('user', null);

export function getMockUserData(): User {
	return {
		id: -1,
		email: 'demo account',
		verified: false,
		is_superuser: false,
		is_shadowuser: true,
		remaining_free_actions: 10
	};
}
